import React, { useEffect } from 'react';
import 'firebase/database';
import App from './components/App';
import withMenu from './hocs/withMenu';
import { fetchData } from './api/menu';

const Menu = () => {
  useEffect(() => {
    const { search } = window.location || {};
    const urlParams = new URLSearchParams(search);
    const state = process.env.REACT_APP_MODE || '1';
    const queryObj = [...urlParams.entries()].reduce((p, n) => {
      const [key, value] = n;
      return {
        ...p,
        [key]: value,
      };
    }, {});

    (async () => {
      await fetchData({
        query: {
          ...queryObj,
          env: state,
        },
      });
    })();
  }, []);

  return (
    <App />
  );
};

export default withMenu(Menu);
